import { getAppState } from "../state";
import { config } from "../config/config";

// FIXME: Since all parentalLevel values are currently string typed, if we want to deal with
// numbers instead, for now we have to include the '+' operator before getAppState statement.
export function getNumericParentalLevel() {
  return +getAppState().parentalLevel;
}

export function isAccessLimitedByParentalLevel() {
  return getNumericParentalLevel() === config.get().limitedAppAccessParentalLevel;
}

export function isAccessAllowedByParentalLevel() {
  return getNumericParentalLevel() === config.get().unlimitedAppAccessParentalLevel;
}
